export default __webpack_public_path__ + "static/media/shadown.44efff78.png";